const state = {
  genders: ['Male', 'Female'],
  states: ["Alabama", "Alaska", "Arkansas", "Arizona", "California", "Colorado", "Connecticut",
    "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
    "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
    "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
    "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ],
  ranks: ['10th Gup', '9th Gup', '8th Gup', '7th Gup', '6th Gup', '5th Gup', '4th Gup', '3rd Gup', '2nd Gup ',
    '1st Gup', 'Cho-Dan Bo', 'Cho-Dan', 'E-Dan', 'Sam-Dan', 'Sa-Dan', 'O-Dan', 'Yuk-Dan'
  ]
};

const getters = {
  getGenders: state => state.genders,
  getStates: state => state.states,
  getRanks: state => state.ranks
};

export default {
  state,
  getters
};